import { ProductCatalogueCSVUpload } from 'Service/ApiService';
import { useRef, useState } from 'react';
import { showAlert } from 'utils/ErrorMessage';

const ProductCatalogueController = () => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [severity, setSeverity] = useState();
  const [message, setMessage] = useState();
  const [alert, setAlert] = useState(false);

  const handleFileChange = (event) => {
    setAlert(false);
    const file = event.target.files[0];
    const fileExtension = file.name.split('.').pop().toLowerCase();

    if (fileExtension === 'csv') {
      const now = new Date();
      const date = now.toLocaleDateString('en-CA'); // YYYY-MM-DD
      const time = now.toLocaleTimeString('en-GB').replace(/:/g, '-'); // HH-MM-SS

      const newFileName = `ProductCatalogueUpload_${date}_${time}.csv`;
      const newFile = new File([file], newFileName, { type: file.type });
      setSelectedFile(newFile);
    } else {
      event.target.value = '';
      setSelectedFile(null);
      clearFileInput();
      showAlert('Please upload a CSV file', 'Validation');
    }
  };

  const clearFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    try {
      setAlert(false);
      if (selectedFile) {
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('user'));
        const response = await ProductCatalogueCSVUpload(selectedFile, user.userCode);

        if (response && response.success === 'true') {
          setMessage(response.msg);
          setSeverity('green');
        } else {
          setMessage(response.msg);
          setSeverity('red');
        }
        setAlert(true);
        setLoading(false);

        setTimeout(() => {
          setSelectedFile(null);
          clearFileInput();
          setAlert(false);
        }, 5000);
      } else {
        setMessage('Please select a file to upload');
        setSeverity('red');
        setAlert(true);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error during Product Catalogue upload:', error);
    }
  };

  return {
    loading,
    handleFileChange,
    handleUpload,
    fileInputRef,
    severity,
    message,
    alert
  };
};

export default ProductCatalogueController;
